import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { clearFilter } from '../redux/Filter/action';
import SingleBlog from './SingleBlog';
const Blogs = () => {
  const blogs = useSelector((state) => state.blogs);
  const filter = useSelector((state) => state.filter);
  const dispatch = useDispatch();
  const handleClearFilter = () => {
    dispatch(clearFilter());
  };
  return (
    <section className="relative bg-gray-50 pt-8 pb-20 px-4 sm:px-6 lg:pt-16 lg:pb-16 lg:px-8">
      <div className="absolute inset-0">
        <div className="bg-white h-1/3 sm:h-2/3"></div>
      </div>
      <div className="relative max-w-7xl mx-auto">
        <div className="text-center">
          <h2 className="text-3xl tracking-tight font-extrabold text-gray-900 sm:text-4xl">
            ALL BLOGS ARE HERE
          </h2>
          <p className="mt-3 max-w-2xl mx-auto text-xl text-gray-500 sm:mt-4">
            Lorem ipsum dolor sit amet consectetur, adipisicing elit. Ipsa
            libero labore natus atque, ducimus sed.
          </p>
        </div>
        {(filter.category != '' || filter.author != '') && (
          <p
            onClick={handleClearFilter}
            className="text-end text-red-300  font-bold  cursor-pointer"
          >
            clear filter
          </p>
        )}
        {/* <!-- card grid  --> */}
        <div className="mt-12 max-w-lg mx-auto grid gap-5 lg:grid-cols-3 lg:max-w-none">
          {blogs
            .filter((blg) => {
              if (filter.value == '') {
                return blg;
              } else if (
                blg.title.toLowerCase().includes(filter?.value.toLowerCase())
              ) {
                return blg;
              }
            })
            .filter((categoryBlog) => {
              if (filter.category == '') {
                return categoryBlog;
              } else if (categoryBlog.category.includes(filter.category)) {
                return categoryBlog;
              }
            })
            .filter((authorBlog) => {
              if (filter.author == '') {
                return authorBlog;
              } else if (authorBlog?.authorName?.includes(filter.author)) {
                return authorBlog;
              }
            })
            .map((blog) => (
              <SingleBlog blog={blog} key={blog.id} />
            ))}
        </div>
      </div>
    </section>
  );
};

export default Blogs;
